export default __webpack_public_path__ + "static/media/719.ef9dc1b0.png";